<ion-content class="home-bg">
  <ion-grid>
    <!-- auth msg -->
    <ion-row class="ion-justify-content-center" *ngIf="!(isAuthenticated$ | async)">
      <ion-col size="12" size-md="4">
        <ion-card>
          <ion-card-content class="c3-flex ion-align-items-center ion-justify-content-center ion-padding">
            <ion-icon [src]="'lock-alert' | getIcon" color="secondary" size="large" class="ion-margin-end"></ion-icon>
            <span>Autenticati per avere accesso a tutte le funzionalità del cruscotto</span>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <ion-row class="ion-align-items-center ion-justify-content-around">
      <ng-container *ngFor="let entry of navigationEntries">
        <ng-container *ngIf="!(entry.hide | async)">
          <ion-col size="auto">
            <ion-item class="home-button" button [routerLink]="entry.route" [queryParams]="entry.routeQueryParams">
              <ion-grid class="ion-no-padding">
                <ion-row class="img-box">
                  <ion-col class="c3-flex ion-align-items-center ion-justify-content-center">
                    <img [src]="entry.image" [alt]="entry.label" />
                  </ion-col>
                </ion-row>
                <ion-row class="label-box ion-align-items-center ion-justify-content-center"
                         [style.background]="entry.color">
                  <ion-col>
                    <strong>{{ entry.label }}</strong>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-item>
          </ion-col>
        </ng-container>
      </ng-container>
    </ion-row>
  </ion-grid>
</ion-content>